import React, { useEffect, useState } from "react";
import api from "../../../services/api";
import SheetsFilters from "../../Common/SheetsFilters";
import SheetPreview from "../../Common/SheetPreview";
import DownloadButton from "../../Common/DownloadButton";

export default function CompletedSheetsList() {
  const [filters, setFilters] = useState({
    namePart: "",
    startTime: null,
    endTime: null,
  });

  const [sheets, setSheets] = useState([]);
  const [expanded, setExpanded] = useState(null);

  const fetchSheets = async () => {
    const res = await api.post("/layouting/sheets/completed", filters);
    setSheets(res.data.elements || []);
  };

  useEffect(() => {
    fetchSheets();
  }, []);

  const toggleExpand = (id) => {
    setExpanded(expanded === id ? null : id);
  };

  return (
    <>
      <SheetsFilters
        filters={filters}
        setFilters={setFilters}
        onSearch={fetchSheets}
      />

      {sheets.map((s) => (
        <div key={s.id} className="border rounded p-2 mb-2">
          <div
            className="d-flex justify-content-between"
            onClick={() => toggleExpand(s.id)}
            style={{ cursor: "pointer" }}
          >
            <div>
              <div className="fw-bold">{s.name}</div>
              <small className="text-muted">
                {new Date(s.creationTime).toLocaleString()}
              </small>
            </div>

            <div className="col-md-3 col-6">
              <small className="text-muted d-block">Создатель:</small>
              <div>{s.createdBy}</div>
            </div>

          </div>

          {expanded === s.id && (
            <div className="card-footer d-flex flex-column gap-2">
              
              <div className="mt-2">
                <SheetPreview jobId={s.jobId} width={600} height={400}/>
              </div>

              <div className="d-flex flex-wrap gap-2">
                <DownloadButton
                  endpoint={`/layouting/sheets/download/${s.id}`}
                  buttonLabel="Скачать .cdr"
                  method="post"
                  defaultFileName="sheet.cdr"
                />
              </div>

            </div>
          )}
        </div>
      ))}
    </>
  );
}
